const rankingItems = [
  {
    rank: 1,
    title: '流浪地球3',
    subtitle: '国产科幻巨制 · 吴京主演',
    hot: '★★★★★',
    views: '1280万',
    trend: 'hot',
    tag: '科幻',
  },
  {
    rank: 2,
    title: '繁城之下',
    subtitle: '古装悬疑探案 · 白宇帆主演',
    hot: '★★★★☆',
    views: '965万',
    trend: 'up',
    tag: '悬疑',
  },
  {
    rank: 3,
    title: '欢笑一家人',
    subtitle: '合家欢喜剧 · 沈腾马丽',
    hot: '★★★★★',
    views: '892万',
    trend: 'up',
    tag: '喜剧',
  },
  {
    rank: 4,
    title: '海洋深处',
    subtitle: 'BBC纪录大片 · 深海探索',
    hot: '★★★★☆',
    views: '756万',
    trend: 'new',
    tag: '纪录',
  },
  {
    rank: 5,
    title: '全職高手第三季',
    subtitle: '电竞热血国漫 · 蝴蝶蓝原著',
    hot: '★★★★☆',
    views: '689万',
    trend: 'up',
    tag: '动漫',
  },
  {
    rank: 6,
    title: '九龙城寨之围城',
    subtitle: '港式动作片 · 古天乐洪金宝',
    hot: '★★★★☆',
    views: '623万',
    trend: 'up',
    tag: '动作',
  },
  {
    rank: 7,
    title: '繁花',
    subtitle: '王家卫首部剧集 · 胡歌主演',
    hot: '★★★★★',
    views: '598万',
    trend: 'hot',
    tag: '剧情',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-12 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              热度榜单
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              本周最受欢迎的影视作品 TOP 7
            </p>
          </div>
          <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-background-50 text-xs text-foreground-500">
            <i className="ri-time-line"></i>
            <span>实时更新</span>
          </div>
        </div>

        <div className="bg-background-50 rounded-2xl overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 p-4 md:p-5 transition-colors duration-200 hover:bg-background-100 cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-secondary-100/50' : ''
              }`}
            >
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 font-bold text-sm ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-300 text-background-50'
                  : item.rank === 3
                  ? 'bg-primary-200 text-primary-700'
                  : 'bg-secondary-100 text-secondary-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                    {item.title}
                  </h3>
                  {item.trend === 'hot' && (
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-primary-100 text-primary-600 text-xs font-medium">
                      <i className="ri-fire-line text-[10px]"></i>热播
                    </span>
                  )}
                  {item.trend === 'up' && (
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium">
                      <i className="ri-arrow-up-line text-[10px]"></i>上升
                    </span>
                  )}
                  {item.trend === 'new' && (
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-600 text-xs font-medium">
                      <i className="ri-sparkling-line text-[10px]"></i>新进
                    </span>
                  )}
                </div>
                <p className="text-xs text-foreground-500 truncate">{item.subtitle}</p>
              </div>

              <div className="hidden sm:flex items-center gap-2 text-xs text-accent-500 shrink-0">
                <span>{item.hot}</span>
              </div>

              <div className="hidden md:block text-xs text-foreground-500 shrink-0 whitespace-nowrap">
                {item.views}次播放
              </div>

              <span className="hidden sm:inline-block px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-600 text-xs font-medium shrink-0">
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}